import { Dropdown } from 'antd';

import { FeatureSidebarNav, FeatureSidebarNavItem } from '@/components/layout/insideShell.styles';
import { FeatureSidebarProjectName } from '@/layout/style';

/** Project name row in the feature sidebar (desktop shell). */
export function ProjectFeatureSidebarHeader({ title, isError }) {
    const text = isError ? 'Project' : title || '';
    return <FeatureSidebarProjectName>{text}</FeatureSidebarProjectName>;
}

/**
 * Project tab list — same primitives as default feature nav (`FeatureSidebarNav` + `FeatureSidebarNavItem`).
 * Context menu: Open / new tab / copy link (same behavior as the mobile Ant `Menu` items).
 */
export function ProjectFeatureSidebarMenu({ rows, selectedKeys, onTabNavigate, onCopyLink }) {
    if (!rows?.length) return null;

    return (
        <FeatureSidebarNav aria-label="Project tabs">
            {rows.map((row) => {
                const active = Array.isArray(selectedKeys) && selectedKeys.includes(row.key);
                const contextMenuItems = [
                    { key: 'open', label: 'Open' },
                    { key: 'open-new-tab', label: 'Open in new tab' },
                    { type: 'divider' },
                    { key: 'copy-link', label: 'Copy link' },
                ];
                return (
                    <Dropdown
                        key={row.key}
                        trigger={['contextMenu']}
                        menu={{
                            items: contextMenuItems,
                            onClick: ({ key: actionKey, domEvent }) => {
                                domEvent?.stopPropagation();
                                domEvent?.preventDefault();
                                if (actionKey === 'open') {
                                    onTabNavigate?.(row.key);
                                } else if (actionKey === 'open-new-tab') {
                                    window.open(row.tabAbsoluteUrl, '_blank', 'noopener,noreferrer');
                                } else if (actionKey === 'copy-link') {
                                    onCopyLink?.(row.tabAbsoluteUrl);
                                }
                            },
                        }}
                    >
                        <FeatureSidebarNavItem
                            type="button"
                            $active={active}
                            onClick={() => onTabNavigate?.(row.key)}
                        >
                            <span className="feature-nav-icon">{row.icon}</span>
                            <span className="feature-nav-label">{row.labelText || '—'}</span>
                        </FeatureSidebarNavItem>
                    </Dropdown>
                );
            })}
        </FeatureSidebarNav>
    );
}
